/** Link ufficiali collegati alla sezione Economia Locale / vetrina territoriale. */
export const SAGRA_PORCHETTA_ITALICA_URL = "https://www.sagradellaporchettaitalica.com/";

export function isExternalHref(href) {
  return typeof href === "string" && (href.startsWith("http://") || href.startsWith("https://"));
}
